import { atom } from 'recoil';
import { EnterpriseGroupBuy } from '~/types/enterpriseGroupBuy';
import { FirebaseDataStatus } from '~/types/utilities';

const globalEnterpriseGroupBuyAtom = atom({
  key: 'globalEnterpriseGroupBuyData',
  default: {
    cart: FirebaseDataStatus.INIT,
    platform: FirebaseDataStatus.INIT,
    data: null as EnterpriseGroupBuy | null,
  },
});

export default globalEnterpriseGroupBuyAtom;
